import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useInView } from "react-intersection-observer";
import { OptionLoading } from "./OptionLoading";
export const InfiniteScroll = memo(({ onView, loading }) => {
    const [ref] = useInView({
        threshold: 0.999,
        onChange: (inView) => inView && onView?.(),
    });
    return (_jsxs(_Fragment, { children: [loading && _jsx(OptionLoading, {}), onView && _jsx("div", { ref: ref })] }));
});
